<template>
    <div class="apply">
        <!-- banner -->
        <div class="banner">
            <div class="img"><img src="@/assets/img/ggu_logo.png" alt=""></div>
            <p>世毕盟本科
                <span>申请服务</span>
            </p>
        </div>
        <!-- 介绍 -->
        <div class="introduce">
            <div class="intr">
                <p>【世毕盟本科申请】帮助众多世毕盟高中阶段学员斩获的所有Offer均来自美国TOP 50名校，其中更有65%以上来自TOP 30名校，其中包括耶鲁大学、哥伦比亚大学、斯坦福大学、达特茅斯学院、西北大学、杜克大学、布朗大学、埃默里大学、加州大学伯克利分校等美国top名校Offer。</p>
                <p>世毕盟申全球，多位世毕盟学员收获英国牛津大学、剑桥大学、帝国理工学院、新加坡国立大学等世界名校。</p>
            </div>
        </div>
        <!-- 服务特色 -->
        <div class="service">
            <p class="title">服务特色</p>
            <div class="li">
                <div class="left">
                    <span class="iconfont icon-diqiu"></span>
                </div>
                <div class="right">
                    <p class="li_title">世毕盟申请全球</p>
                    <p class="content">【世毕盟本科申请】学员，可以同时申请美国、英国、加拿大、日本等国家的本科项目，最大化效益。</p>
                </div>
            </div>
            <div class="li">
                <div class="left">
                    <span class="iconfont icon-xinxi"></span>
                </div>
                <div class="right">
                    <p class="li_title">特色活动资源</p>
                    <p class="content">海量活动资源，个性化定制活动方案。特别是【爱科研】学术项目，学员不仅可以在学术大牛指导下进行扎实的科研，还可以获得Additional Letter（附加推荐信，用于本科网申系统），使得学员脱颖而出；</p>
                    <img src="@/assets/img/apply.png" alt="">
                </div>
            </div>
            <div class="li">
                <div class="left">
                    <span class="iconfont icon-tuandui"></span>
                </div>
                <div class="right">
                    <p class="li_title">四位一体专家服务</p>
                    <p class="info">经验丰富的班主任</p>
                    <p class="info">Top名校本科毕业的Mentor</p>
                    <p class="info">GGU Native Expert Team文书把关</p>
                    <p class="info">GGU Native模拟面试专家</p>
                </div>
            </div>
            <div class="li">
                <div class="left">
                    <span class="iconfont icon-jindu"></span>
                </div>
                <div class="right">
                    <p class="li_title">科学的系统管理</p>
                    <p class="content">以科学且系统的项目管理方式全程跟踪学员申请进度，冲刺极限也确保稳妥。</p>
                </div>
            </div>
        </div>
        <div class="button">
            <p @click="goList">世毕盟本科申请部分案例</p>
        </div>
        <div class="button_" v-if="isFixed">
            <p @click="goList">世毕盟本科申请部分案例</p>
        </div>

        <!-- 咨询团队 -->
        <div class="teacher">
            <p class="title">咨询团队 <span @click="goTeacher">查看更多 ></span></p>
            <ul>
                <li v-for="(item,index) in teacherList" :key="index">
                    <div class="left">
                        <img :src="item.img" alt="">
                    </div>
                    <div class="right">
                        <p class="name">{{item.name}} <span>{{item.label}}</span></p>
                        <p class="info">{{item.info}}</p>
                    </div>
                </li>
            </ul>
        </div> 
    </div>
</template>

<script>

export default {
    data() {
        return {
            isFixed:true,
            teacherList:[{
                name:"龚晓然",
                img:require("@/assets/img/gong.jpg"),
                label:"世毕盟创始人",
                info:"清华大学硕士， 多年美国留学培训及咨询经验，学生遍及美国各大名校。"
            },{
                name:"Chloe",
                img:require("@/assets/img/Chloe.jpg"),
                label:"MIT本科",
                info:"4年MIT本科面试和招生工作经验，丰富指导世毕盟学员申请美国、英国名校本科项目的工作经验。"
            }],
            wxImg: "http://www.gguconsulting.com/try/sbm/Public/img/ggu_logo.jpg",
        }
    },
    methods:{
        goList(){
            this.$router.push({
                path: "/applylist"
            })
        },
        goTeacher(){
            this.$router.push({
                path: "/applyteacher"
            })
        },
        // 监听滚动条高度变化
        handleScroll(e) {
            let clientHeight = document.getElementsByClassName("button")[0]?document.getElementsByClassName("button")[0].offsetTop:0;
            // console.log(e.target.scrollingElement.scrollTop,clientHeight,11111)
            if (e.target.scrollingElement.scrollTop > 865) {
                this.isFixed = false;
            } else {
                this.isFixed = true;
            }
        },
    },
    mounted(){
         // 监听滚动条高度变化
        window.addEventListener('scroll', this.handleScroll, true)
    },
    created() {
        this.WXConfig.wxShowMenu("世毕盟本科申请","美英top名校申请专家，让你脱颖而出！","http://www.gguconsulting.com/try/sbm/index.php/#/apply",this.wxImg);
    },
    destroyed(){
        // 监听滚动条高度变化
        window.removeEventListener('scroll', this.handleScroll, true)
    }
}
</script>

<style lang="less" scoped>
.apply {
    background:#fff;
    padding-bottom:150px;
    // font-family: 'PingFang Regular';
    .banner {
        width: 100%;
        height: 360px;
        position: relative;
        background:url("../../assets/img/apply_banner.jpg") no-repeat;
        p {
            padding-top: 125px;
            text-align: center;
            font-size: 47px;
            color: #fff;
            span {
                color: #FEEA8B;
            }
        }
        .img {
            width: 170px;
            // height: 38px;
            position: absolute;
            top: 40px;
            left: 43px;
            img {
                width: 100%;
                // height: 100%;
            }
        }
    }
    .introduce {
        background:#fff;
        .intr{
            width:700px;
            position: relative;
            background:#fff;
            padding:40px 45px;
            box-sizing: border-box;
            border-radius:20px;
            margin:-115px 25px 0;
            p{
                font-size: 28px;
                color:#4D4D4D;
                line-height:50px;
                margin-bottom:40px;
            }
        }
    }
    .service{
       border-top:20px solid #F5F5F5;
       .title{
           text-align: center;
           color:#1A1A1A;
           font-size: 38px;
           padding:60px 0 70px;
           line-height: 38px;
       }
       .li{
           padding:0 35px;
           display: flex;
           margin-bottom:80px;
           .left{
               width:70px;
               margin-right:30px;
               span{
                   display: inline-block;
                   color:#fecb5f;
                   font-size: 70px;
                   line-height: 54px;
               }
           }
           .right{
               flex:1;
               .li_title{
                   font-size: 32px;
                   color:#020202;
                   font-weight: 600;
                   margin-bottom:30px;
                   line-height: 32px;
               }
               .content,.info{
                   font-size: 28px;
                   color:#4D4D4D;
                   line-height:50px;
               }
               .info{
                   padding-left:37px;
                   position: relative;
                   &::before{
                        content:"";
                        width:7px;
                        height:7px;
                        background:rgba(77,77,77,1);
                        border-radius:50%;
                        position: absolute;
                        left: 0;
                        top:50%;
                        transform: translateY(-50%);
                   }
               }
               img{
                   width:421px;
                   margin-top:30px;
               }
           }
       }
    }
    .button,.button_{
        width:100%;
        height:170px;
        background:#fff;
        padding-top:20px;
        p{
            width:521px;
            height:88px;
            background:rgba(254,203,95,1);
            border-radius:44px;
            text-align: center;
            line-height: 88px;
            color:#1A1A1A;
            font-size: 32px;
            margin:0 auto;
        }
    }
    .button_{
        position: fixed;
        bottom:0px;
        left: 0;
    }
    .teacher{
        border-top:20px solid #F5F5F5;
        padding:0 25px;
        .title{
            color:#1A1A1A;
            font-size: 38px;
            padding:60px 0px 70px;
            line-height: 38px;
            span{
                color:#1E6BB8;
                font-size:28px;
                float:right;
                margin-top:2px;
            }
        }
        ul{
            // margin-top:20px;
            li{
                border:1px solid rgba(204,204,204,1);
                border-radius:20px;
                margin-bottom:20px;
                display:flex;
                padding:37px 28px;
                .left{
                    width:114px;
                    height:148px;
                    background:#ddd;
                    margin-right:30px;
                    img{
                        width:100%;
                        height:100%;
                    }
                }
                .right{
                    flex:1;
                    .name{
                        font-size:32px;
                        color:#000000;
                        span{
                            display:inline-block;
                            padding:0px 15px;
                            border-radius:17px;
                            background:#FECB5F;
                            color:#080808;
                            font-size:24px;
                            line-height:32px;
                            margin-left:15px;
                            vertical-align: middle;
                            margin-top:-10px;
                        }
                    }
                    .info{
                        margin-top:20px;
                        font-size:26px;
                        color:#4D4D4D;
                        line-height:44px;
                    }
                }
            }
        }
    }
}
</style>